import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { CategoryDialogComponent } from './category-dialog/category-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { AppSettings, Settings } from 'src/app/app.settings';
import {Category} from "src/app/app.models";
import {CategoryService} from "../categories/categories.service";
import {SystemApp} from "../../../constans/SystemConfigurations";

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
  providers: [ CategoryService ]
})
export class CategoriesComponent implements OnInit {
  public categories:Category[] = []; 
  public page: any;
  public count = 6;
  public settings:Settings;
  searchText: any='';

  constructor(public appService: AppService,
              public dialog: MatDialog,
              public appSettings:AppSettings,
              public categoryService:CategoryService
            ) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit(): void {
    this.getCategories();
  }

  public getCategories(){
    this.categories = null;
    this.categoryService.getCategory().subscribe(category =>{
      this.categories = category.object_list.map((res)=>{
        return{
          id: res.id,
          name: res.name,
          description: res.description,
          hasSubCategory: res.hasSubCategory,
          parentId: res.parentId,
          image: res.image ? res.image : 'https://TOBA LIGHT-light.com:8000/media/LOGO.png'
        }
      })
    })

   /* this.appService.getCategories().subscribe(data => {
      this.categories = data; 
      this.categories.shift();
    });*/
  }

  public onPageChanged(event){
    this.page = event; 
    window.scrollTo(0,0); 
  }
  public addCategory(category:Category){
    this.categoryService.addCategory(category).subscribe(category => this.getCategories());
  }
  public updateCategory(category:Category){
    this.categoryService.updateCategory(category).subscribe(category => this.getCategories());
  }


  public openCategoryDialog(category){
    const dialogRef = this.dialog.open(CategoryDialogComponent, {
      data: {
        category: category,
        categories: this.categories
      },
      panelClass: ['theme-dialog'],
      autoFocus: false,
      direction: (this.settings.rtl) ? 'rtl' : 'ltr'
    });

    dialogRef.afterClosed().subscribe(category => {
      console.log(category)
      if(category){
        category.parentId = category.parentId == 0 ? null : category.parentId
        const index: number = this.categories.findIndex(x => x.id == category.id);
        if(index !== -1){
          this.categoryService.updateCategory(category).subscribe(res=> {
            this.getCategories();
          })

        }
        else{
          this.categoryService.addCategory(category).subscribe(res=> {
            this.getCategories();
          })
        }
      }else{
        this.getCategories();
      }
    });
  }

  public remove(category:any){
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: {
        title: "Confirm Action",
        message: "Are you sure you want remove this category?"
      }
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if(dialogResult){
        const index: number = this.categories.indexOf(category);
        this.categoryService.deleteCategory(category.id).subscribe(res=> {
          if (index !== -1) {
            this.categories.splice(index, 1);
            setTimeout(()=>this.getCategories(),250);
          }
        })
      }
    });
  }

  onSearchText($event) {
    this.searchText = $event.target.value;
  }
}
